import React from 'react'
import classNames from 'classnames'

import DiscountTimeIcon from '../../../../assets/_V2/svg/DiscountTimeIcon'
import SellingPlanIcon from '../../../../assets/_V2/svg/SellingPlanIcon'
import MegaphoneIcon from '../../../../assets/_V2/svg/MegaphoneIcon'
import BonnetIcon from '../../../../assets/_V2/svg/BonnetIcon'

import styles from './styles.module.scss'
import {Locales} from "../../../localization/types";

export const getData = (locale: Locales) => {
    if (locale === 'ru-BY') {
        return [
            {
                heading: (
                    <span className={classNames(styles.heading, styles.colorBluePrimary)}>
                        <DiscountTimeIcon />
                        Старт продаж
                    </span>
                ),
                textarea: (
                    <>
                        <span className={styles.textarea__desktop}>
                          Запуск заведения — это море работы. Делегируй нам настройку системы,
                          <br />
                          освободи время для ремонта, поиска персонала и поставщиков.
                        </span>
                        <span className={styles.textarea__tablet}>
                          Запуск заведения — это море работы. Делегируй нам настройку системы,
                        <br />
                        освободи время для ремонта, поиска персонала и поставщиков.
                        </span>
                        <span className={styles.textarea__mobile}>
                          Запуск заведения — это море работы. Делегируй нам настройку системы,
                          освободи время для ремонта, поиска персонала и поставщиков.
                        </span>
                    </>
                ),
                table: [
                    {
                        id: 0,
                        col1: 'Услуги',
                        col2: 'Описание',
                        col3: 'Стоимость',
                    },
                    {
                        id: 1,
                        col1: (
                        <span className={styles.col1}>
                            Подключим и&nbsp;настроим <br/> оборудование
                        </span>
                        ),
                        col2: (
                            <ul className={classNames(styles.col2__ul, styles.colorBluePrimary)}>
                                <li>Установим и настроим онлайн-кассу, принтеры, денежный ящик</li>
                                <li>Настроим роутер</li>
                                <li>Подготовим весь комплект оборудования, а при покупке оборудования в нашем магазине сделаем бесплатную доставку</li>
                            </ul>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorBluePrimary)}>
                                от 50 Р
                            </span>
                        ),
                    },
                    {
                        id: 2,
                        col1: (
                            <span className={styles.col1}>
                                Заполним <br/> номенклатуру
                            </span>
                        ),
                        col2: (
                            <ul className={classNames(styles.col2__ul, styles.colorBluePrimary)}>
                                <li>Добавим в меню ваши блюда и напитки с техкартами.</li>
                                <li>Настроим корректное списание продуктов на складе для точного учета.</li>
                            </ul>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorBluePrimary)}>
                                от 90 Р
                            </span>
                        ),
                    },
                ],
            },
            {
                heading: (
                    <span className={classNames(styles.heading, styles.colorFuchsia)}>
                        <SellingPlanIcon />
                        Поиск точек роста
                    </span>
                ),
                textarea: (
                    <>
                        <span className={styles.textarea__desktop}>
                          На этапе, когда важно сохранять ресурсы для поиска новых идей и точек
                          роста,
                          <br />
                          мы настроим автоматическую отчётность для аналитики и упростим ряд
                          других задач.
                        </span>
                        <span className={styles.textarea__tablet}>
                          На этапе, когда важно сохранять ресурсы для поиска новых идей и точек
                          роста,
                          <br />
                          мы настроим автоматическую отчётность для аналитики и упростим ряд
                          других задач.
                        </span>
                        <span className={styles.textarea__mobile}>
                          На этапе, когда важно сохранять ресурсы для поиска новых идей и точек
                          роста, мы настроим автоматическую отчётность для аналитики и упростим
                          ряд других задач.
                        </span>
                    </>
                ),
                table: [
                    {
                        id: 0,
                        col1: 'Услуги',
                        col2: 'Описание',
                        col3: 'Стоимость',
                    },
                    {
                        id: 1,
                        col1: (
                        <span className={styles.col1}>
                            Настроим виджеты <br/> для аналитики
                        </span>
                        ),
                        col2: (
                            <ul className={classNames(styles.col2__ul, styles.colorFuchsia)}>
                                <li>
                                    Сделаем отображение нужных показателей продаж: по выручке, блюдам, каждому сотруднику, заведениям. Увидишь, какие каналы нужно подтянуть.
                                </li>
                            </ul>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorFuchsia)}>
                                от 40 Р
                            </span>
                        ),
                    },
                    {
                        id: 2,
                        col1: (
                            <span className={styles.col1}>
                                Расположим блюда на&nbsp;терминале по&nbsp;маржинальности
                            </span>
                        ),
                        col2: (
                            <ul className={classNames(styles.col2__ul, styles.colorFuchsia)}>
                                <li>
                                    Проанализируем и расположим блюда на терминале так, чтобы на первых позициях стояли более маржинальные. Кассиры смогут предлагать их в первую очередь и увеличивать средний чек.
                                </li>
                            </ul>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorFuchsia)}>
                                от 50 Р
                            </span>
                        ),
                    },
                    {
                        id: 3,
                        col1: (
                            <span className={styles.col1}>
                                Еженедельно будем вносить приходные накладные
                            </span>
                        ),
                        col2: (
                            <ul className={classNames(styles.col2__ul, styles.colorFuchsia)}>
                                <li>
                                    Покажем, как своевременное проведение документов помогает следить за движением продуктов и себестоимостью блюд.
                                </li>
                                <li>Сэкономим тебе 10–12 часов в неделю.</li>
                            </ul>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorFuchsia)}>
                                от 120 Р
                            </span>
                        ),
                    },
                ],
            },
            {
                heading: (
                    <span className={classNames(styles.heading, styles.colorCyan)}>
                        <MegaphoneIcon />
                        Привлечение гостей
                      </span>
                ),
                textarea: (
                    <>
                        <span className={styles.textarea__desktop}>
                          Продумывание программ лояльности — это творческая и важная работа для привлечения гостей. <br/> Общайся с посетителями, а мы займемся технической настройкой акций в CRM-системе Quick Resto.
                        </span>
                        <span className={styles.textarea__tablet}>
                          Продумывание программ лояльности — это творческая и важная работа для
                          привлечения гостей.
                          <br />
                          Общайся с посетителями, а мы займемся технической настройкой акций в
                          CRM-системе Quick&nbsp;Resto.
                        </span>
                        <span className={styles.textarea__mobile}>
                          Продумывание программ лояльности — это творческая и важная работа для
                          привлечения гостей. Общайся с посетителями, а мы займемся технической
                          настройкой акций
                          <br />
                          в CRM-системе Quick&nbsp;Resto.
                        </span>
                    </>
                ),
                table: [
                    {
                        id: 0,
                        col1: 'Услуги',
                        col2: 'Описание',
                        col3: 'Стоимость',
                    },
                    {
                        id: 1,
                        col1: <span className={styles.col1}>Добавим акции и скидки</span>,
                        col2: (
                            <ul className={classNames(styles.col2__ul, styles.colorCyan)}>
                                <li>
                                    Настроим акции, которые хочешь запустить, и мы сделаем так, чтобы они корректно отображалась на терминале. Кассирам не придётся думать, как применить скидку, — всё наглядно.
                                </li>
                            </ul>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorCyan)}>
                              от 40 Р
                            </span>
                        ),
                    },
                    {
                        id: 2,
                        col1: (
                            <span className={styles.col1}>Внесём гостей в CRM и&nbsp;разделим их по группам </span>
                        ),
                        col2: (
                            <ul className={classNames(styles.col2__ul, styles.colorCyan)}>
                                <li>Добавим гостей в базу.</li>
                                <li>
                                    Научим настраивать разный уровень привилегий, чтобы возвращать и радовать постоянных гостей.
                                </li>
                            </ul>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorCyan)}>
                                от 120 Р
                            </span>
                        ),
                    },
                    {
                        id: 3,
                        col1: <span className={styles.col1}>Обучим модулю CRM</span>,
                        col2: (
                            <ul className={classNames(styles.col2__ul, styles.colorCyan)}>
                                <li>Расскажем о принципах и способах создания бонусной системы.</li>
                                <li>
                                    Научим создавать акции, комбо, специальные предложения и промокоды с подходящими примерами для твоего типа заведения.
                                </li>
                                <li>
                                    Покажем, как работает настройка начисления бонусов и оповещения гостей. Полную программу курса уточняй у менеджера
                                </li>
                            </ul>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorCyan)}>
                                от 200 Р
                            </span>
                        ),
                    },
                ],
            },
            {
                heading: (
                    <span className={classNames(styles.heading, styles.colorPurple)}>
                        <BonnetIcon />
                        Обучение
                      </span>
                ),
                textarea: (
                    <>
                        <span className={styles.textarea__desktop}>
                          Если хочешь действовать самостоятельно, мы обучим тебя работе в
                          системе или проверим настройки
                          <br />
                          уже действующего облака. Узнаешь, как использовать автоматизацию,
                          чтобы получать больше выгоды.
                        </span>
                        <span className={styles.textarea__tablet}>
                          Если хочешь действовать самостоятельно, мы обучим тебя работе в
                          системе или проверим настройки
                          <br />
                          уже действующего облака. Узнаешь, как использовать автоматизацию,
                          чтобы получать больше выгоды.
                        </span>
                                        <span className={styles.textarea__mobile}>
                          Если хочешь действовать самостоятельно, мы обучим тебя работе в
                          системе или проверим настройки уже действующего облака. Узнаешь, как
                          использовать автоматизацию, чтобы получать больше выгоды.
                        </span>
                    </>
                ),
                table: [
                    {
                        id: 0,
                        col1: 'Услуги',
                        col2: 'Описание',
                        col3: 'Стоимость',
                    },
                    {
                        id: 1,
                        rowStyles: styles.rowStyles,
                        col1: <span className={styles.col1}>Аудит работы в бэк-офисе</span>,
                        col2: (
                            <>
                                <span
                                    className={classNames(styles.col2__heading, styles.colorPurple)}
                                >
                                  Углубленный аудит
                                    {' '}
                                    <span>от 400 Р</span>
                                </span>
                                <ul className={classNames(styles.col2__ul, styles.colorPurple)}>
                                    <li>
                                        Поправим слабые места и сделаем так, чтобы система полноценно помогала в бизнесе.
                                    </li>
                                    <li>
                                        Сможешь уменьшить затраты в заведении и найдёшь способы заработать больше денег с помощью маркетинговых акций и инструментов аналитики.
                                    </li>
                                </ul>
                            </>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorPurple)}>
                            от 400 Р
                          </span>
                        ),
                    },
                    {
                        id: 2,
                        rowStyles: styles.rowStyles,
                        col1: <span className={styles.col1} />,
                        col2: (
                            <>
                                <span
                                    className={classNames(styles.col2__heading, styles.colorPurple)}
                                >
                                  Аудит инвентаризации
                                    {' '}
                                    <span>от 100 Р</span>
                                </span>
                                <ul className={classNames(styles.col2__ul, styles.colorPurple)}>
                                    <li>
                                        Проверим расхождения в остатках на складе и в системе учёта, выявим причины.
                                    </li>
                                    <li>
                                        Проверим действия персонала, отвечающего за кухню и склад
                                    </li>
                                </ul>
                            </>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorPurple)}>
                            от 250 Р
                          </span>
                        ),
                    },
                    {
                        id: 3,
                        col1: <span className={styles.col1}>Курс «Quick Resto за 4 дня»</span>,
                        col2: (
                            <ul className={classNames(styles.col2__ul, styles.colorPurple)}>
                                <li>
                                    Освоишь: CRM-систему и IT-решения для привлечения гостей, инструменты аналитики и контроля, учёт продуктов и другое.
                                </li>
                            </ul>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorPurple)}>
                                от 650 Р
                            </span>
                        ),
                    },
                ],
            },
        ]
    }
    if (locale === 'ru-KZ') {
        return [
            {
                heading: (
                    <span className={classNames(styles.heading, styles.colorBluePrimary)}>
                        <DiscountTimeIcon />
                        Старт продаж
                    </span>
                ),
                textarea: (
                    <>
                        <span className={styles.textarea__desktop}>
                          Запуск заведения — это море работы. Делегируй нам настройку системы,
                          <br />
                          освободи время для ремонта, поиска персонала и поставщиков.
                        </span>
                                        <span className={styles.textarea__tablet}>
                          Запуск заведения — это море работы. Делегируй нам настройку системы,
                          <br />
                          освободи время для ремонта, поиска персонала и поставщиков.
                        </span>
                                        <span className={styles.textarea__mobile}>
                          Запуск заведения — это море работы. Делегируй нам настройку системы,
                          освободи время для ремонта, поиска персонала и поставщиков.
                        </span>
                    </>
                ),
                table: [
                    {
                        id: 0,
                        col1: 'Услуги',
                        col2: 'Описание',
                        col3: 'Стоимость',
                    },
                    {
                        id: 1,
                        col1: (
                            <span className={styles.col1}>
                                Поставим на учёт
                                <br />
                                онлайн-кассу
                            </span>
                        ),
                        col2: (
                            <ul className={classNames(styles.col2__ul, styles.colorBluePrimary)}>
                                <li>Зарегистрируем в WebKassa</li>
                                <li>
                                    Подключим к ОФД
                                </li>
                            </ul>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorBluePrimary)}>
                               от 9 000 ₸
                            </span>
                        ),
                    },
                    {
                        id: 2,
                        col1: (
                            <span className={styles.col1}>
                                Подключим и настроим
                                <br />
                                оборудование
                            </span>
                        ),
                        col2: (
                            <ul className={classNames(styles.col2__ul, styles.colorBluePrimary)}>
                                <li>Установим и настроим онлайн-кассу, принтеры, денежный ящик</li>
                                <li>Настроим роутер</li>
                                <li>
                                    Подготовим весь комплект оборудования, а при покупке оборудования
                                    в нашем магазине сделаем бесплатную доставку
                                </li>
                            </ul>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorBluePrimary)}>
                                от 24 000 ₸
                            </span>
                        ),
                    },
                    {
                        id: 3,
                        col1: (
                            <span className={styles.col1}>
                                Заполним
                                <br />
                                номенклатуру
                            </span>
                        ),
                        col2: (
                            <ul className={classNames(styles.col2__ul, styles.colorBluePrimary)}>
                                <li>Добавим в меню ваши блюда и напитки с техкартами.</li>
                                <li>Настроим корректное списание продуктов на складе для точного учёта.</li>
                            </ul>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorBluePrimary)}>
                                от 9 000 ₸
                            </span>
                        ),
                    },
                    {
                        id: 4,
                        col1: <span className={styles.col1}>Добавим пищевую ценность</span>,
                        col2: (
                            <ul className={classNames(styles.col2__ul, styles.colorBluePrimary)}>
                                <li>
                                    Пропишем пищевую ценность для ингредиентов по их средним
                                    показателям, пищевая ценность блюд посчитается автоматически.
                                </li>
                            </ul>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorBluePrimary)}>
                                от 9 000 ₸
                            </span>
                        ),
                    },
                ],
            },
            {
                heading: (
                    <span className={classNames(styles.heading, styles.colorFuchsia)}>
                        <SellingPlanIcon />
                        Поиск точек роста
                    </span>
                ),
                textarea: (
                    <>
                        <span className={styles.textarea__desktop}>
                         На этапе, когда важно сохранять ресурсы для поиска новых идей и точек роста, <br/>
                        мы настроим автоматическую отчётность для аналитики и упростим ряд других задач.
                        </span>
                        <span className={styles.textarea__tablet}>
                          На этапе, когда важно сохранять ресурсы для поиска новых идей и точек
                          роста,
                          <br />
                          мы настроим автоматическую отчётность для аналитики и упростим ряд
                          других задач.
                        </span>
                        <span className={styles.textarea__mobile}>
                          На этапе, когда важно сохранять ресурсы для поиска новых идей и точек
                          роста, мы настроим автоматическую отчётность для аналитики и упростим
                          ряд других задач.
                        </span>
                    </>
                ),
                table: [
                    {
                        id: 0,
                        col1: 'Услуги',
                        col2: 'Описание',
                        col3: 'Стоимость',
                    },
                    {
                        id: 1,
                        col1: (
                            <span className={styles.col1}>
                                Настроим виджеты
                                <br />
                                для аналитики
                            </span>
                        ),
                        col2: (
                            <ul className={classNames(styles.col2__ul, styles.colorFuchsia)}>
                                <li>
                                    Сделаем отображение нужных показателей продаж: по выручке, блюдам,
                                    каждому сотруднику, заведениям. Увидишь, какие каналы нужно
                                    подтянуть.
                                </li>
                            </ul>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorFuchsia)}>
                                от 3000 ₸
                            </span>
                        ),
                    },
                    {
                        id: 2,
                        col1: (
                            <span className={styles.col1}>
                                Расположим блюда
                                <br />
                                на терминале
                                <br />
                                по маржинальности
                            </span>
                        ),
                        col2: (
                            <ul className={classNames(styles.col2__ul, styles.colorFuchsia)}>
                                <li>
                                    Проанализируем и расположим блюда на терминале так, чтобы на
                                    первых позициях стояли более маржинальные. Кассиры смогут
                                    предлагать их в первую очередь и увеличивать средний чек.
                                </li>
                            </ul>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorFuchsia)}>
                                от 18 000 ₸
                            </span>
                        ),
                    },
                    {
                        id: 3,
                        col1: (
                            <span className={styles.col1}>
                                Еженедельно будем вносить
                                <br />
                                приходные накладные
                            </span>
                        ),
                        col2: (
                            <ul className={classNames(styles.col2__ul, styles.colorFuchsia)}>
                                <li>
                                    Покажем, как своевременное проведение документов помогает следить
                                    за движением продуктов и себестоимостью блюд.
                                </li>
                                <li>Сэкономим тебе 10–12 часов в неделю.</li>
                            </ul>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorFuchsia)}>
                               от 18 000 ₸
                            </span>
                        ),
                    },
                ],
            },
            {
                heading: (
                    <span className={classNames(styles.heading, styles.colorCyan)}>
                        <MegaphoneIcon />
                        Привлечение гостей
                    </span>
                ),
                textarea: (
                    <>
                        <span className={styles.textarea__desktop}>
                          Продумывание программ лояльности — это творческая и важная работа для привлечения гостей. <br/> Общайся с посетителями, а мы займемся технической настройкой акций в CRM-системе Quick Resto.
                        </span>
                                        <span className={styles.textarea__tablet}>
                          Продумывание программ лояльности — это творческая и важная работа для
                          привлечения гостей.
                          <br />
                          Общайся с посетителями, а мы займемся технической настройкой акций в
                          CRM-системе Quick&nbsp;Resto.
                        </span>
                                        <span className={styles.textarea__mobile}>
                          Продумывание программ лояльности — это творческая и важная работа для
                          привлечения гостей. Общайся с посетителями, а мы займемся технической
                          настройкой акций
                          <br />
                          в CRM-системе Quick&nbsp;Resto.
                        </span>
                    </>
                ),
                table: [
                    {
                        id: 0,
                        col1: 'Услуги',
                        col2: 'Описание',
                        col3: 'Стоимость',
                    },
                    {
                        id: 1,
                        col1: <span className={styles.col1}>Добавим акции и скидки</span>,
                        col2: (
                            <ul className={classNames(styles.col2__ul, styles.colorCyan)}>
                                <li>
                                    Настроим акции, которые хочешь запустить, и мы сделаем так, чтобы
                                    они корректно отображалась на терминале. Кассирам не придётся
                                    думать, как применить скидку, — всё наглядно.
                                </li>
                            </ul>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorCyan)}>
                                от 6 000 ₸
                            </span>
                        ),
                    },
                    {
                        id: 2,
                        col1: (
                            <span className={styles.col1}>
                                Внесём гостей в CRM
                                <br />
                                и разделим их по группам
                            </span>
                        ),
                        col2: (
                            <ul className={classNames(styles.col2__ul, styles.colorCyan)}>
                                <li>Добавим гостей в базу.</li>
                                <li>
                                    Научим настраивать разный уровень привилегий, чтобы возвращать и
                                    радовать постоянных гостей.
                                </li>
                            </ul>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorCyan)}>
                                от 17 000 ₸
                            </span>
                        ),
                    },
                    {
                        id: 3,
                        col1: <span className={styles.col1}>Обучим модулю CRM</span>,
                        col2: (
                            <ul className={classNames(styles.col2__ul, styles.colorCyan)}>
                                <li>Расскажем о принципах и способах создания бонусной системы.</li>
                                <li>
                                    Научим создавать акции, комбо, специальные предложения и промокоды
                                    с подходящими примерами для твоего типа заведения.
                                </li>
                                <li>
                                    Покажем, как работает настройка начисления бонусов и оповещения
                                    гостей. Полную программу курса уточняй у менеджера
                                </li>
                            </ul>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorCyan)}>
                                от 28 000 ₸
                            </span>
                        ),
                    },
                ],
            },
            {
                heading: (
                    <span className={classNames(styles.heading, styles.colorPurple)}>
                        <BonnetIcon />
                        Обучение
                    </span>
                ),
                textarea: (
                    <>
                        <span className={styles.textarea__desktop}>
                          Если хочешь действовать самостоятельно, мы обучим тебя работе в системе или проверим настройки уже действующего облака. Узнаешь, как использовать автоматизацию, чтобы получать больше выгоды.
                        </span>
                                        <span className={styles.textarea__tablet}>
                          Если хочешь действовать самостоятельно, мы обучим тебя работе в
                          системе или проверим настройки
                          <br />
                          уже действующего облака. Узнаешь, как использовать автоматизацию,
                          чтобы получать больше выгоды.
                        </span>
                                        <span className={styles.textarea__mobile}>
                          Если хочешь действовать самостоятельно, мы обучим тебя работе в
                          системе или проверим настройки уже действующего облака. Узнаешь, как
                          использовать автоматизацию, чтобы получать больше выгоды.
                        </span>
                    </>
                ),
                table: [
                    {
                        id: 0,
                        col1: 'Услуги',
                        col2: 'Описание',
                        col3: 'Стоимость',
                    },
                    {
                        id: 1,
                        rowStyles: styles.rowStyles,
                        col1: <span className={styles.col1}>Аудит работы в бэк-офисе</span>,
                        col2: (
                            <>
                                <span
                                    className={classNames(styles.col2__heading, styles.colorPurple)}
                                >
                                  Углубленный аудит
                                    {' '}
                                    <span>от 17 000 ₸</span>
                                </span>
                                <ul className={classNames(styles.col2__ul, styles.colorPurple)}>
                                    <li>
                                        Поправим слабые места и сделаем так, чтобы система полноценно помогала в бизнесе.
                                    </li>
                                    <li>
                                        Сможешь уменьшить затраты в заведении и найдёшь способы заработать больше денег с помощью маркетинговых акций и инструментов аналитики.
                                    </li>
                                </ul>
                            </>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorPurple)}>
                               от 17 000 ₸
                            </span>
                        ),
                    },
                    {
                        id: 2,
                        rowStyles: styles.rowStyles,
                        col1: <span className={styles.col1} />,
                        col2: (
                            <>
                                <span
                                    className={classNames(styles.col2__heading, styles.colorPurple)}
                                >
                                  Аудит инвентаризации
                                    {' '}
                                    <span>от 30 000 ₸</span>
                                </span>
                                <ul className={classNames(styles.col2__ul, styles.colorPurple)}>
                                    <li>
                                        Проверим расхождения в остатках на складе и в системе учёта,
                                        выявим причины.
                                    </li>
                                    <li>Проверим действия персонала, отвечающего за кухню и склад</li>
                                </ul>
                            </>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorPurple)}>
                                от 30 000 ₸
                            </span>
                        ),
                    },
                    {
                        id: 4,
                        col1: <span className={styles.col1}>Курс «Quick Resto за 4 дня»</span>,
                        col2: (
                            <ul className={classNames(styles.col2__ul, styles.colorPurple)}>
                                <li>
                                    Освоишь: CRM-систему и IT-решения для привлечения гостей, инструменты аналитики и контроля, учёт продуктов и другое.
                                </li>
                            </ul>
                        ),
                        col3: (
                            <span className={classNames(styles.col3, styles.colorPurple)}>
                                от 79 000 ₸
                            </span>
                        ),
                    },
                ],
            },
        ]
    }
    return [
        {
            heading: (
                <span className={classNames(styles.heading, styles.colorBluePrimary)}>
        <DiscountTimeIcon />
        Старт продаж
      </span>
            ),
            textarea: (
                <>
        <span className={styles.textarea__desktop}>
          Запуск заведения — это море работы. Делегируй нам настройку системы,
          <br />
          освободи время для ремонта, поиска персонала и поставщиков.
        </span>
                    <span className={styles.textarea__tablet}>
          Запуск заведения — это море работы. Делегируй нам настройку системы,
          <br />
          освободи время для ремонта, поиска персонала и поставщиков.
        </span>
                    <span className={styles.textarea__mobile}>
          Запуск заведения — это море работы. Делегируй нам настройку системы,
          освободи время для ремонта, поиска персонала и поставщиков.
        </span>
                </>
            ),
            table: [
                {
                    id: 0,
                    col1: 'Услуги',
                    col2: 'Описание',
                    col3: 'Стоимость',
                },
                {
                    id: 1,
                    col1: (
                        <span className={styles.col1}>
            Поставим на учёт
            <br />
            онлайн-кассу
          </span>
                    ),
                    col2: (
                        <ul className={classNames(styles.col2__ul, styles.colorBluePrimary)}>
                            <li>Зарегистрируем онлайн-кассу в ФНС</li>
                            <li>
                                Настроим личный кабинет ОФД, активируем или продлим его
                                обслуживание
                            </li>

                        </ul>
                    ),
                    col3: (
                        <span className={classNames(styles.col3, styles.colorBluePrimary)}>
            от 3 000 ₽
          </span>
                    ),
                },
                {
                    id: 2,
                    col1: (
                        <span className={styles.col1}>
                            Привезём и настроим
                            <br />
                            оборудование
                          </span>
                    ),
                    col2: (
                        <ul className={classNames(styles.col2__ul, styles.colorBluePrimary)}>
                            <li>Установим и настроим онлайн-кассу, принтеры, денежный ящик</li>
                            <li>Настроим роутер</li>
                            <li>
                                При покупке оборудования в нашем магазине, сделаем бесплатную доставку
                                (по Москве в пределах МКАД)
                            </li>
                        </ul>
                    ),
                    col3: (
                        <span className={classNames(styles.col3, styles.colorBluePrimary)}>
            от 5 000 ₽
          </span>
                    ),
                },
                {
                    id: 3,
                    col1: (
                        <span className={styles.col1}>
            Заполним
            <br />
            номенклатуру
          </span>
                    ),
                    col2: (
                        <ul className={classNames(styles.col2__ul, styles.colorBluePrimary)}>
                            <li>Добавим в меню ваши блюда и напитки с техкартами.</li>
                            <li>Настроим корректное списание продуктов на складе для точного учёта.</li>
                        </ul>
                    ),
                    col3: (
                        <span className={classNames(styles.col3, styles.colorBluePrimary)}>
            от 3 000 ₽
          </span>
                    ),
                },
                {
                    id: 4,
                    col1: <span className={styles.col1}>Добавим пищевую ценность</span>,
                    col2: (
                        <ul className={classNames(styles.col2__ul, styles.colorBluePrimary)}>
                            <li>
                                Пропишем пищевую ценность для ингредиентов по их средним
                                показателям, пищевая ценность блюд посчитается автоматически.
                            </li>
                        </ul>
                    ),
                    col3: (
                        <span className={classNames(styles.col3, styles.colorBluePrimary)}>
            от 3 000 ₽
          </span>
                    ),
                },
            ],
        },
        {
            heading: (
                <span className={classNames(styles.heading, styles.colorFuchsia)}>
        <SellingPlanIcon />
        Поиск точек роста
      </span>
            ),
            textarea: (
                <>
        <span className={styles.textarea__desktop}>
          На этапе, когда важно сохранять ресурсы для поиска новых идей и точек
          роста,
          <br />
          мы настроим автоматическую отчётность для аналитики и упростим ряд
          других задач.
        </span>
                    <span className={styles.textarea__tablet}>
          На этапе, когда важно сохранять ресурсы для поиска новых идей и точек
          роста,
          <br />
          мы настроим автоматическую отчётность для аналитики и упростим ряд
          других задач.
        </span>
                    <span className={styles.textarea__mobile}>
          На этапе, когда важно сохранять ресурсы для поиска новых идей и точек
          роста, мы настроим автоматическую отчётность для аналитики и упростим
          ряд других задач.
        </span>
                </>
            ),
            table: [
                {
                    id: 0,
                    col1: 'Услуги',
                    col2: 'Описание',
                    col3: 'Стоимость',
                },
                {
                    id: 1,
                    col1: (
                        <span className={styles.col1}>
            Настроим виджеты
            <br />
            для аналитики
          </span>
                    ),
                    col2: (
                        <ul className={classNames(styles.col2__ul, styles.colorFuchsia)}>
                            <li>
                                Сделаем отображение нужных показателей продаж: по выручке, блюдам,
                                каждому сотруднику, заведениям. Увидишь, какие каналы нужно
                                подтянуть.
                            </li>
                        </ul>
                    ),
                    col3: (
                        <span className={classNames(styles.col3, styles.colorFuchsia)}>
            от 500 ₽
          </span>
                    ),
                },
                {
                    id: 2,
                    col1: (
                        <span className={styles.col1}>
            Расположим блюда
            <br />
            на терминале
            <br />
            по маржинальности
          </span>
                    ),
                    col2: (
                        <ul className={classNames(styles.col2__ul, styles.colorFuchsia)}>
                            <li>
                                Проанализируем и расположим блюда на терминале так, чтобы на
                                первых позициях стояли более маржинальные. Кассиры смогут
                                предлагать их в первую очередь и увеличивать средний чек.
                            </li>
                        </ul>
                    ),
                    col3: (
                        <span className={classNames(styles.col3, styles.colorFuchsia)}>
            от 3 000 ₽
          </span>
                    ),
                },
                {
                    id: 3,
                    col1: (
                        <span className={styles.col1}>
            Еженедельно будем вносить
            <br />
            приходные накладные
          </span>
                    ),
                    col2: (
                        <ul className={classNames(styles.col2__ul, styles.colorFuchsia)}>
                            <li>
                                Покажем, как своевременное проведение документов помогает следить
                                за движением продуктов и себестоимостью блюд.
                            </li>
                            <li>Сэкономим тебе 10–12 часов в неделю.</li>
                        </ul>
                    ),
                    col3: (
                        <span className={classNames(styles.col3, styles.colorFuchsia)}>
            от 3 000 ₽
          </span>
                    ),
                },
                {
                    id: 4,
                    col1: (
                        <span className={styles.col1}>
            Настроим связь с «ЕГАИС»
            <br />
            под ключ
          </span>
                    ),
                    col2: (
                        <ul className={classNames(styles.col2__ul, styles.colorFuchsia)}>
                            <li>Изготовим токен с ключом ЕГАИС.</li>
                            <li>
                                Зарегистрируем личный кабинет в ЕГАИС, получим ключ RSA, установим
                                УТМ-модуль на ПК, настроим систему ЕГАИСИК и свяжем её с Quick
                                Resto.
                            </li>
                        </ul>
                    ),
                    col3: (
                        <span className={classNames(styles.col3, styles.colorFuchsia)}>
            от 9 000 ₽
          </span>
                    ),
                },
            ],
        },
        {
            heading: (
                <span className={classNames(styles.heading, styles.colorCyan)}>
        <MegaphoneIcon />
        Привлечение гостей
      </span>
            ),
            textarea: (
                <>
        <span className={styles.textarea__desktop}>
          Продумывание программ лояльности — это творческая и важная работа для
          привлечения гостей.
          <br />
          Общайся с посетителями, а мы займемся технической настройкой акций в
          CRM-системе Quick&nbsp;Resto.
        </span>
                    <span className={styles.textarea__tablet}>
          Продумывание программ лояльности — это творческая и важная работа для
          привлечения гостей.
          <br />
          Общайся с посетителями, а мы займемся технической настройкой акций в
          CRM-системе Quick&nbsp;Resto.
        </span>
                    <span className={styles.textarea__mobile}>
          Продумывание программ лояльности — это творческая и важная работа для
          привлечения гостей. Общайся с посетителями, а мы займемся технической
          настройкой акций
          <br />
          в CRM-системе Quick&nbsp;Resto.
        </span>
                </>
            ),
            table: [
                {
                    id: 0,
                    col1: 'Услуги',
                    col2: 'Описание',
                    col3: 'Стоимость',
                },
                {
                    id: 1,
                    col1: <span className={styles.col1}>Добавим акции и скидки</span>,
                    col2: (
                        <ul className={classNames(styles.col2__ul, styles.colorCyan)}>
                            <li>
                                Настроим акции, которые хочешь запустить, и мы сделаем так, чтобы
                                они корректно отображалась на терминале. Кассирам не придётся
                                думать, как применить скидку, — всё наглядно.
                            </li>
                        </ul>
                    ),
                    col3: (
                        <span className={classNames(styles.col3, styles.colorCyan)}>
            от 1 000 ₽
          </span>
                    ),
                },
                {
                    id: 2,
                    col1: (
                        <span className={styles.col1}>
            Внесём гостей в CRM
            <br />
            и разделим их по группам
          </span>
                    ),
                    col2: (
                        <ul className={classNames(styles.col2__ul, styles.colorCyan)}>
                            <li>Добавим гостей в базу.</li>
                            <li>
                                Научим настраивать разный уровень привилегий, чтобы возвращать и
                                радовать постоянных гостей.
                            </li>
                        </ul>
                    ),
                    col3: (
                        <span className={classNames(styles.col3, styles.colorCyan)}>
            от 2 500 ₽
          </span>
                    ),
                },
                {
                    id: 3,
                    col1: <span className={styles.col1}>Обучим модулю CRM</span>,
                    col2: (
                        <ul className={classNames(styles.col2__ul, styles.colorCyan)}>
                            <li>Расскажем о принципах и способах создания бонусной системы.</li>
                            <li>
                                Научим создавать акции, комбо, специальные предложения и промокоды
                                с подходящими примерами для твоего типа заведения.
                            </li>
                            <li>
                                Покажем, как работает настройка начисления бонусов и оповещения
                                гостей. Полную программу курса уточняй у менеджера
                            </li>
                        </ul>
                    ),
                    col3: (
                        <span className={classNames(styles.col3, styles.colorCyan)}>
            от 4 990 ₽
          </span>
                    ),
                },
            ],
        },
        {
            heading: (
                <span className={classNames(styles.heading, styles.colorPurple)}>
        <BonnetIcon />
        Обучение
      </span>
            ),
            textarea: (
                <>
        <span className={styles.textarea__desktop}>
          Если хочешь действовать самостоятельно, мы обучим тебя работе в
          системе или проверим настройки
          <br />
          уже действующего облака. Узнаешь, как использовать автоматизацию,
          чтобы получать больше выгоды.
        </span>
                    <span className={styles.textarea__tablet}>
          Если хочешь действовать самостоятельно, мы обучим тебя работе в
          системе или проверим настройки
          <br />
          уже действующего облака. Узнаешь, как использовать автоматизацию,
          чтобы получать больше выгоды.
        </span>
                    <span className={styles.textarea__mobile}>
          Если хочешь действовать самостоятельно, мы обучим тебя работе в
          системе или проверим настройки уже действующего облака. Узнаешь, как
          использовать автоматизацию, чтобы получать больше выгоды.
        </span>
                </>
            ),
            table: [
                {
                    id: 0,
                    col1: 'Услуги',
                    col2: 'Описание',
                    col3: 'Стоимость',
                },
                {
                    id: 1,
                    rowStyles: styles.rowStyles,
                    col1: <span className={styles.col1}>Аудит работы в бэк-офисе</span>,
                    col2: (
                        <>
            <span
                className={classNames(styles.col2__heading, styles.colorPurple)}
            >
              Базовый аудит
                {' '}
                <span>от 2 500 ₽</span>
            </span>
                            <ul className={classNames(styles.col2__ul, styles.colorPurple)}>
                                <li>
                                    Проверим, правильно ли настроены методы списания, права доступа,
                                    складская документация и другое.
                                </li>
                                <li>
                                    Выясним, откуда берутся недостачи на складе, найдем, где можно
                                    сэкономить с пользой для бизнеса.
                                </li>
                            </ul>
                        </>
                    ),
                    col3: (
                        <span className={classNames(styles.col3, styles.colorPurple)}>
            от 2 500 ₽
          </span>
                    ),
                },
                {
                    id: 2,
                    rowStyles: styles.rowStyles,
                    col1: <span className={styles.col1} />,
                    col2: (
                        <>
            <span
                className={classNames(styles.col2__heading, styles.colorPurple)}
            >
              Углубленный аудит
                {' '}
                <span>от 10 000 ₽</span>
            </span>
                            <ul className={classNames(styles.col2__ul, styles.colorPurple)}>
                                <li>
                                    Поправим слабые места и сделаем так, чтобы система полноценно
                                    помогала в бизнесе.
                                </li>
                                <li>
                                    Сможешь уменьшить затраты в заведении и найдёшь способы
                                    заработать больше денег с помощью маркетинговых акций и
                                    инструментов аналитики.
                                </li>
                            </ul>
                        </>
                    ),
                    col3: (
                        <span className={classNames(styles.col3, styles.colorPurple)}>
            от 10 000 ₽
          </span>
                    ),
                },
                {
                    id: 3,
                    rowStyles: styles.rowStyles,
                    col1: <span className={styles.col1} />,
                    col2: (
                        <>
            <span
                className={classNames(styles.col2__heading, styles.colorPurple)}
            >
              Аудит инвентаризации
                {' '}
                <span>от 5 500 ₽</span>
            </span>
                            <ul className={classNames(styles.col2__ul, styles.colorPurple)}>
                                <li>
                                    Проверим расхождения в остатках на складе и в системе учёта,
                                    выявим причины.
                                </li>
                                <li>Проверим действия персонала, отвечающего за кухню и склад</li>
                            </ul>
                        </>
                    ),
                    col3: (
                        <span className={classNames(styles.col3, styles.colorPurple)}>
            от 5 500 ₽
          </span>
                    ),
                },
                {
                    id: 4,
                    col1: <span className={styles.col1}>Курс «Quick Resto за 4 дня»</span>,
                    col2: (
                        <ul className={classNames(styles.col2__ul, styles.colorPurple)}>
                            <li>
                                Освоишь: CRM-систему и IT-решения для привлечения гостей,
                                инструменты аналитики и контроля, учёт продуктов и другое.
                            </li>
                        </ul>
                    ),
                    col3: (
                        <span className={classNames(styles.col3, styles.colorPurple)}>
            от 14 990 ₽
          </span>
                    ),
                },
            ],
        },
    ]
}
